import { FmcsaInspectionListDto } from "../../../common/data/service-proxies";
import { ListMenuItemProps } from "../../common/list/ListMenuItemProps";
import { isBoolean } from "lodash";
import { ListItemIcon, ListItemText, MenuItem } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import resourceNames from "../../../common/data/resourceNames";

interface Props extends ListMenuItemProps<FmcsaInspectionListDto> {}

export const ShowFmcsaInspectionMenuItem = ({
  record,
  hidden,
  label,
  icon,
  onClick,
  onSuccess,
  ...rest
}: Props) => {
  const history = useHistory();

  if (!record?.id) {
    return null;
  }

  if (isBoolean(hidden)) {
    if (hidden) {
      return null;
    }
  } else {
    if (hidden && hidden(record)) {
      return null;
    }
  }

  return (
    <>
      <MenuItem
        {...rest}
        className="actions-menu-item"
        onClick={(e) => {
          history.push(
            `/${resourceNames.HOS_FMCSA_DATA_TRANSFER}/${record.id}/show`
          );
        }}
      >
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText>{label}</ListItemText>
      </MenuItem>
    </>
  );
};
